<template>
  <BTextFieldDate
    v-model="value"
    :loading="isLoading"
    :disabled="disabled"
    :min="new Date()"
    placeholder="Выбрать дату"
    class="LKRoadmapsFeedLabelDate"
    @input="onInput"
  >
    <template #input="{ on, attrs }">
      <div
        v-bind="attrs"
        :class="{ 'cursor-pointer': !disabled, 'cursor-default': disabled }"
        class="label__date w-inline-block"
        v-on="on"
      >
        <div class="date__icon">
          <IconToggle
            v-if="isLoading"
            :loading="isLoading"
          />

          <img
            v-else
            src="/images/i-date-2.svg"
            loading="lazy"
            alt=""
            class="date__icon-img"
          >
        </div>

        <div
          class="text-sm mod--date LKRoadmapsFeedLabelDate__label"
          v-text="label"
        />
      </div>
    </template>
  </BTextFieldDate>
</template>

<script>
import { dateFormatter } from '@/helpers/dateFormatter'

import BTextFieldDate from '@/components/forms/BTextFieldDate.vue'
import IconToggle from '@/components/lk/icons/LKIconToggle.vue'


const DATE_FORMAT = 'D MMM YYYY'

export default {
  name: 'LKRoadmapsFeedLabelDate',
  components: {
    BTextFieldDate,
    IconToggle,
  },
  inheritAttrs: false,
  props: {
    from: String,
    to: String,
    disabled: Boolean,
  },
  data: () => ({
    value: null,
    isLoading: false,
  }),
  computed: {
    label() {
      return [
        dateFormatter(this.from, DATE_FORMAT),
        this.from === this.to ? null : dateFormatter(this.to, DATE_FORMAT),
      ].filter(Boolean).join(' - ') || 'Нет даты'
    },
  },
  watch: {
    to: {
      immediate: true,
      handler(value) {
        this.value = value
      },
    },
  },
  methods: {
    onInput(date) {
      this.$emit('input', date, this.toggleLoading)
    },
    toggleLoading() {
      this.isLoading = !this.isLoading
      return this.toggleLoading
    },
  },
}
</script>

<style lang="scss">

.LKRoadmapsFeedLabelDate {
  &__label {
    min-width: 100px;
  }

  .v-date-picker-table {
    &.v-btn--active {
      background-color: $webflow-color-blue-dark;
    }

    &.v-btn--outlined {
      border-color: $webflow-color-blue-dark;
      border-width: 2px;
    }
  }
}
</style>
